<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Dischaged Patients",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "DISCHARGED PATIENTS",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Client Section",
          active: true,
        },
        {
          text: "Discharged Clients",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patient_name",
          sortable: true,
          label: "PATIENT NAME",
        },
        {
          key: "patient_code",
          sortable: true,
          label: "PATIENT CODE",
        },
        {
          key: "patient_contact",
          sortable: true,
          label: "PATIENT CONTACT",
        },
        {
          key: "patient_gender",
          sortable: true,
          label: "PATIENT GENDER",
        },
        {
          key: "wards",
          sortable: true,
          label: "WARD",
        },
        {
          key: "admission_date",
          sortable: true,
          label: "ADMISSION DATE",
        },
        {
          key: "discharge_date",
          sortable: true,
          label: "DISCHARGE DATE",
        },
        {
          key: "status",
          sortable: true,
          label: "DISCHARGE STATUS",
        },
        {
          key: "officer",
          sortable: true,
          label: "OFFICER",
        },
        {
          key: "followupdate",
          sortable: true,
          label: "FOLLOWUP DATE",
        },
        {
          key: "followupplace",
          sortable: true,
          label: "FOLLOWUP PLACE",
        },
        {
          key: "provisional_diagnosis",
          sortable: true,
          label: "PROVISIONAL DIAGNOSIS",
        },

        {
          key: "final_diagnosis",
          sortable: true,
          label: "FINAL DIAGNOSIS",
        },
        {
          key: "clinical_presentation",
          sortable: true,
          label: "CLINICAL PRESENTATION",
        },
        {
          key: "intervation",
          sortable: true,
          label: "INTERVATION",
        },
        {
          key: "reccomendation",
          sortable: true,
          label: "RECOMMENDATION",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTIONS",
        },
      ],
      data: {
        dto: moment(new Date()).format("YYYY-MM-DD"),
        dfrom: "",
        category: "",
      },

      filterTitle: "",
      fitered_array: [],
      filterreport: {
        title: "DISCHARGED PATIENTS",
        today: moment(new Date()).format("YYYY-MM-DD"),
        date1: '',
        date2: moment(new Date()).format("YYYY-MM-DD"),
        officer: ''
      },
      json_fields: {
        PATIENT_NAME: "patient_name",
        PATIENT_CODE: "patient_code",
        PATIENT_CONTACT: "patient_contact",
        PATIENT_GENDER: "patient_gender",
        WARD: "wards",
        ADMISSION_DATE: "admission_date",
        DISCHARGE_DATE: "discharge_date",
        DISCHARGE_STATUS: "status",
        OFFICER: "officer",
        FOLLOWUP_DATE: "followupplace",
        PROVISIONAL_DIAGNOSIS: "provisional_diagnosis",
        FINAL_DIAGNOSIS: "final_diagnosis",
        CLINICAL_PRESENTATION: "clinical_presentation",
        INTERVATION: "intervation",
        RECOMMENDATION: "reccomendation",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
   
    };
  },
  computed: {
    ...mapGetters("inpatient", ["DischargePatients"]),
    ...mapGetters("staffModule", ["clinic_staff"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.fitered_array ? this.fitered_array.length : 1;
  },
  watch: {
    DischargePatients(newValue) {
      if (newValue.length > 0) {
        this.discharge_reportData();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchDischargedPatients: "inpatient/fetchDischargedPatients",
      FetchStaff: "staffModule/fetchClinicStaff",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    discharge_reportData() {
      this.fitered_array = this.DischargePatients;
      return this.filter_report();
    },
    filter_report() { 
      let startDate = this.filterreport.date1;
      let Discharging_Officer = this.filterreport.officer;
      let endDate = this.filterreport.date2;
      if (Discharging_Officer != "" && endDate != "") { 
        this.filterreport.title = "DISCHARGED PATIENTS BY OFFICER " + this.filterreport.officer;
        this.fitered_array = this.DischargePatients.filter((disch) => {       
          return disch.officer == Discharging_Officer;
        });
      }
      else if (startDate != "" && endDate != "" && Discharging_Officer != "") {
        this.filterreport.title = "DISCHARGED PATIENTS FROM " + this.filterreport.date1 + " TO " + this.filterreport.date2 + " FOR STATUS " + this.filterreport.statuscode;
        this.fitered_array = this.DischargePatients.filter((disch) => {
          return disch.discharge_date >= startDate && disch.discharge_date <= endDate && disch.officer == Discharging_Officer;
        });
      }
      else if (startDate != "" && endDate != "") {
        this.filterreport.title = "DISCHARGED PATIENTS FROM " + this.filterreport.date1 + " TO " + this.filterreport.date2;
        this.fitered_array = this.DischargePatients.filter((disch) => {
          return disch.discharge_date >= startDate && disch.discharge_date <= endDate;
        });
      }
      
    else{
        this.filterreport.title = "DISCHARGED PATIENTS";
        this.fitered_array == this.DischargePatients;
    }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.discharge_reportData();
    this.FetchDischargedPatients();
    this.FetchStaff();
   
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
             <h3 class="card-title mb-2 text-center" v-html="filterreport.title"></h3>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>Discharge Officer</label>
                <model-list-select
                  @input="filter_report()"
                  :list="clinic_staff?clinic_staff:[]"
                  v-model="filterreport.officer"
                  option-value="staffName"
                  option-text="staffName"
                  placeholder="Select discharge officer"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <download-excel
                  class="btn btn-primary"
                  :data="fitered_array"
                  :fields="json_fields"
                  :worksheet="'DISCHARGED PATIENTS REPORT ' + currentdate"
                  type="csv"
                  :name="'dischargedpatients' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="fitered_array ? fitered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  
                     <router-link                   
                    class="btn btn-success btn-sm" :to="{ name: 'DischargeVisit', params: { id:data.item.id }}">
                   Details
                  </router-link>
                </template>
              </b-table>
              <center>
                <h3 v-if="!DischargePatients" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
